var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(this.$route.name !== 'Entrar' && this.$route.name !== 'Error')?_c('div',[_c('menu-principal')],1):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }